import {
  Box,
  Card,
  CardHeader,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { PageBreadcrumb } from "src/components/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";

export const QualityEventsSkeleton = () => (
  <Box
    className="flex flex-col gap-4"
    aria-label="Loading quality events"
    aria-busy="true"
    sx={{
      "& .MuiSkeleton-root": { fontSize: "inherit", lineHeight: "inherit" },
      "& .MuiSkeleton-text": { transform: "scale(1, 0.6)" },
    }}
  >
    <PageHeader
      pageTitleComponent={
        <PageBreadcrumb
          items={[
            { label: "Quality Event Management" },
            { label: <Skeleton width={50} /> },
            { label: <Skeleton sx={{ width: { xs: 60, sm: 80 } }} /> },
          ]}
        />
      }
      rightButtons={<Skeleton variant="rounded" width={100} height={30} />}
    />
    <div className="flex flex-col gap-4 px-3 py-2" aria-hidden="true">
      <section className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => (
          <Box
            key={index}
            sx={{
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "background.paper",
              px: 2,
              py: 1.5,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="overline" sx={{ lineHeight: 1.2 }}>
              <Skeleton width="60%" />
            </Typography>
            <Typography variant="h4">
              <Skeleton width={45} />
            </Typography>
            <Skeleton variant="rounded" height={4} />
          </Box>
        ))}
      </section>
      <Card component="section" variant="outlined" className="overflow-hidden">
        <CardHeader
          title={<Skeleton width={150} />}
          subheader={<Skeleton width="45%" />}
          titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
          subheaderTypographyProps={{ variant: "body1" }}
          sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: "divider" }}
        />
        <Stack
          direction="row"
          alignItems="center"
          gap={0.75}
          sx={{
            height: 42,
            pl: "10px",
            pr: "7px",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton width={100} />
          <Skeleton
            variant="rounded"
            width={28}
            height={28}
            sx={{ ml: "auto" }}
          />
        </Stack>
        <TableContainer>
          <Table
            size="small"
            sx={{
              border: 0,
              minWidth: 700,
              "& .MuiTableCell-root": {
                px: 2,
                py: "9px",
                border: 0,
                borderBottom: 1,
                borderColor: "divider",
              },
              "& .MuiTableCell-head": {
                height: 44,
                py: 0,
                backgroundColor: "background.paper",
              },
              "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root":
                { borderBottom: 0 },
            }}
          >
            <TableHead>
              <TableRow>
                {Array.from({ length: 7 }, (_, column) => (
                  <TableCell key={column}>
                    <Typography variant="caption" sx={{ lineHeight: 1.25 }}>
                      <Skeleton width={column === 0 ? 100 : 55} />
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 5 }, (_, row) => (
                <TableRow key={row}>
                  {Array.from({ length: 7 }, (_, column) => (
                    <TableCell key={column}>
                      <Typography variant={column === 0 ? "body1" : "body2"}>
                        <Skeleton width={column === 0 ? "80%" : "70%"} />
                      </Typography>
                      {column === 0 && (
                        <Typography variant="caption" display="block">
                          <Skeleton width="50%" />
                        </Typography>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  </Box>
);
